import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import { raygun } from "@/services/raygun.ts";
import Role from "@/roles";

export default new Vuex.Store({
  state: {
    token: localStorage.getItem("CTC_AUTH_TOKEN"),
    refreshToken: localStorage.getItem("CTC_REFRESH_TOKEN"),
    context: undefined,
    user: JSON.parse(localStorage.getItem("CTC_USER")),
    isFreeUser: JSON.parse(localStorage.getItem("CTC_IS_FREE_USER")),
    questionnaire: JSON.parse(localStorage.getItem("CTC_CURRENT_QUESTIONNAIRE")),
    questionnaireFilter: localStorage.getItem("QUESTIONNAIRE_FILTER"),
  },
  mutations: {
    SET_AUTH(state, params) {
      if (!params.Token) {
        localStorage.removeItem("CTC_AUTH_TOKEN");
        localStorage.removeItem("CTC_REFRESH_TOKEN");
        localStorage.removeItem("QUESTIONNAIRE_FILTER");
        localStorage.removeItem("CTC_CURRENT_QUESTIONNAIRE");
        localStorage.removeItem("CTC_IS_FREE_USER");
        state.token = undefined;
        state.refreshToken = undefined;
        localStorage.removeItem("CTC_USER");
        state.user = undefined;
      } else {
        state.token = params.Token;
        state.refreshToken = params.RefreshToken;
        delete params.Token;
        delete params.RefreshToken;
        state.user = params;
      }
    },
    SET_CONTEXT(state, context) {
      state.context = context;
    },
    SET_USER(state, user) {
      state.user = user;
    },
    SET_IS_FREE_USER(state, IsFreeUser) {
      state.isFreeUser = IsFreeUser;
    },
    SET_QUESTIONNAIRE(state, questionnaire) {
      state.questionnaire = questionnaire;
    },
    SET_QUESTIONNAIRE_FILTER(state, filter) {
      state.questionnaireFilter = filter;
    },
  },
  actions: {
    init: ({ commit, state }, packages) => {
      commit('SET_CONTEXT', packages.context);
    },
    setQuestionnaireFilter: async ({ commit, state }, params) => {
      commit("SET_QUESTIONNAIRE_FILTER", params);
      await localStorage.setItem("QUESTIONNAIRE_FILTER", params);
    },
    setQuestionnaire: ({ commit }, params) => {
      var questionnaire = params;
      commit('SET_QUESTIONNAIRE', questionnaire);
      localStorage.setItem("CTC_CURRENT_QUESTIONNAIRE", JSON.stringify(questionnaire));
    },
    refresh: ({ commit, state }, params) => {
      var user = params;
      localStorage.setItem("CTC_AUTH_TOKEN", user.Token);
      localStorage.setItem("CTC_REFRESH_TOKEN", user.RefreshToken);
      localStorage.setItem("CTC_USER", JSON.stringify(user));
      commit('SET_AUTH', user);
      state.context.$login.users();
      state.context.$login.ctc();
      state.context.$login.acc();
      try {
        if (user) {
          raygun('setUser', {
            identifier: user.Id,
            isAnonymous: false,
            email: user.Username,
            fullName: user.Name
          });
        }

      } catch (err) {
        console.error("failed not free");
      }
      return user;
    },
    login: ({ commit, state }, params) => {
      var email = params.Email;
      var password = params.Password;
      return state.context.$http.post("api/user/login", { Email: email, Password: password }).then(response => {
        localStorage.setItem("CTC_AUTH_TOKEN", response.data.Token);
        localStorage.setItem("CTC_REFRESH_TOKEN", response.data.RefreshToken);
        localStorage.setItem("CTC_USER", JSON.stringify(response.data));
        commit('SET_AUTH', response.data);
        localStorage.setItem("CTC_IS_FREE_USER", JSON.stringify(false));
        commit('SET_IS_FREE_USER', false);
        state.context.$login.users();
        state.context.$login.ctc();
        state.context.$login.acc();
        try {
          raygun('setUser', {
            identifier: response.data.Id,
            isAnonymous: false,
            email: response.data.Username,
            fullName: response.data.Name
          });
        } catch (err) {
          console.error("failed not free" + err);
        }
        return response.data;
      }).catch(error => {
        Promise.reject(error);
      });
    },
    freeAccess: ({ commit, state }, params) => {
      var email = params.Email;
      return state.context.$http.post("api/freeUser/access/" + email, params).then(resp => {
        localStorage.setItem("CTC_AUTH_TOKEN", resp.data.Token);
        localStorage.setItem("CTC_REFRESH_TOKEN", resp.data.RefreshToken);
        localStorage.setItem("CTC_USER", JSON.stringify(resp.data));
        commit('SET_AUTH', resp.data);
        localStorage.setItem("CTC_IS_FREE_USER", JSON.stringify(true));
        commit('SET_IS_FREE_USER', true);
        try {
          raygun('setUser', {
            identifier: resp.Username,
            isAnonymous: false,
            email: resp.Username,
            fullName: resp.Username
          });
        } catch (err) {
          console.error("failed free");
        }
        return resp.data;
      }).catch(error => {
        Promise.reject(error);
      });
    },
    loginFree: ({ commit, state }, params) => {
      var email = params.email;
      var code = params.code;
      return state.context.$http.post("/api/freeUser/access/" + email + "/" + code).then(resp => {
        if (resp.data.success) {
          const auth = resp.data.auth;
          localStorage.setItem("CTC_AUTH_TOKEN", auth.Token);
          localStorage.setItem("CTC_REFRESH_TOKEN", auth.RefreshToken);
          localStorage.setItem("CTC_USER", JSON.stringify(auth));
          commit('SET_AUTH', auth);
          localStorage.setItem("CTC_IS_FREE_USER", JSON.stringify(true));
          commit('SET_IS_FREE_USER', true);
          try {
            raygun('setUser', {
              identifier: resp.Username,
              isAnonymous: false,
              email: resp.Username,
              fullName: resp.Username
            });
          } catch (err) {
            console.error("failed free");
          }
          return resp.data;
        }
      }).catch(err => {
        state.context.$buefy.notification.open({
          duration: 4000,
          message: "A problem occurred trying to grant access. Please try again later.",
          type: "is-danger"
        });
      });
    },
    logout: ({ commit, state }) => {
      if (state.user) {
        if (!window.frameElement) {
          state.context.$logout.users();
          state.context.$logout.ctc();
          state.context.$logout.acc();
        }

        if (state.isFreeUser) {
          state.context.$http.post("api/freeUser/logout/" + state.user.Username).then(resp => {
            state.context.$router.push({ path: '/login' });
          }).catch(err => {
            Promise.reject(err);
            state.context.$router.push({ path: '/login' });
          });
        } else {
          state.context.$http.post("api/user/logout/" + state.user.Id).then(resp => {
            state.context.$router.push({ path: '/login' });
          }).catch(err => {
            Promise.reject(err);
            state.context.$router.push({ path: '/login' });
          });
        }
      }
      delete state.context.$http.defaults.headers.common["Authorization"];
      commit('SET_AUTH', {});
    },
    silent_logout: ({ commit, state }) => {
      if (state.user) {
        if (!window.frameElement) {
          state.context.$logout.users();
          state.context.$logout.ctc();
          state.context.$logout.acc();
        }

        if (state.isFreeUser) {
          state.context.$http.post("api/freeUser/logout/" + state.user.Username);
        } else {
          state.context.$http.post("api/user/logout/" + state.user.Id);
        }
      }
      delete state.context.$http.defaults.headers.common["Authorization"];
      commit('SET_AUTH', {});
    },
    updateName: ({ commit, state }, params) => {
      var user = JSON.parse(localStorage.getItem("CTC_USER"));
      user.FirstName = params.FirstName;
      user.LastName = params.LastName;
      user.Name = params.FirstName + " " + params.LastName;
      localStorage.setItem("CTC_USER", JSON.stringify(user));
      commit("SET_USER", user);
    }
  },
  getters: {
    isLoggedIn: state => {
      return !!state.token;
    },
    user: state => {
      return state.user;
    },
    isFreeUser: state => {
      return state.isFreeUser;
      if (state.user) {
        return state.user.Roles.some(role => role == Role.FreeAccess);
      } else {
        return false;
      }
    },
    is13Prime: state => {
      if (state.user && state.user.Username.indexOf("@13prime.com") >= 0) {
        return true;
      }
      else
        return false;
    },
    isAdmin: state => {
      if (state.user) {
        return state.user.Roles.some(role => role == Role.Admin);
      } else {
        return false;
      }
    },
    isCountryRespondent: state => {
      if (state.user) {
        return state.user.Roles.some(role => role == Role.CountryRespondent);
      } else {
        return false;
      }
    },
    canDownloadSupporting: state => {
      if (state.user) {
        return state.user.Roles.some(role => role == Role.Admin || role == Role.AWGMember || role == Role.AWGMemberCTC || role == Role.Enhanced || role == Role.CountryRespondent || role == Role.CountryViewer);
      } else {
        return false;
      }
    },
    bus: state => {
      return state.context;
    },
    //dummydata for country name in questionnaire
    currentQuestionnaire: state => {
      return state.questionnaire;
    },
    questionnaireFilter: state => {
      return state.questionnaireFilter;
    },
    isGroupManager: state => {
      if (state.user) {
        return state.user.IsGroupManager;
      } else {
        return false;
      }

    },
  }
});
